export default {
  CurvaEquilibrio: 'engineering.water-on-paper.parameters-tab.balance-curve',
  VolumeGas: 'engineering.water-on-paper.parameters-tab.gas-volume',
  DeveConsiderarTempoEstabilizacao: 'engineering.water-on-paper.parameters-tab.consider-stabilization-time',
  EnergiaAtivacaoPapel: 'engineering.water-on-paper.parameters-tab.paper-activation-energy',
  EspessuraPapel: 'engineering.water-on-paper.parameters-tab.paper-thickness',
  DeveConsiderarTipoOleo: 'engineering.water-on-paper.parameters-tab.consider-oil-type',
  ConstanteSolubilidadeOleo: 'engineering.water-on-paper.parameters-tab.oil-solubility-constant',
  PressaoAtmosferica: 'engineering.water-on-paper.parameters-tab.atmospheric-pressure',
  TemperaturaReferencia: 'engineering.water-on-paper.parameters-tab.reference-temperature',
  AlturaEstimadaEntreConservadorTopoEnrolamento: 'engineering.water-on-paper.parameters-tab.estimated-height',
  MinimaDiferencaTemperaturaFormacaoBolha: 'engineering.water-on-paper.parameters-tab.minimum-allowable-difference',
  AguaPapelAdmissivel: 'engineering.water-on-paper.parameters-tab.permissible-paper-water',
  Tdgc: 'engineering.water-on-paper.tdgc',
  TipoOleo: 'fields.asset.transformer.oil-type',
};
